import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface Props {
  width: number;
  height: number;
  fill: string;
}
function ChevronUpIcon(props: Props) {
  const { width, height, fill } = props;
  return (
    <SVGUniqueID>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.648 15.249a1.2 1.2 0 0 1-1.697 0L12 11.297 8.049 15.25a1.2 1.2 0 0 1-1.698-1.697l4.8-4.8a1.2 1.2 0 0 1 1.697 0l4.8 4.8a1.2 1.2 0 0 1 0 1.697z"
          fill={fill}
        />
      </svg>
    </SVGUniqueID>
  );
}

ChevronUpIcon.defaultProps = {
  width: 24,
  height: 24,
  fill: '#64748B'
};

export { ChevronUpIcon };
